export const API_URL = "https://api.mproperty.me/api/";
export const FILES_URL = "https://api.mproperty.me/";
